/**
 * MagicLoginRedirect.js — dev-only magic-link landing page.
 * URL pattern: /parent-magic?token=<JWT>&to=/parent-dashboard
 * Drops the token into localStorage and navigates to the target route.
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const MagicLoginRedirect = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    const to = params.get('to') || '/parent-dashboard';
    if (token) {
      localStorage.setItem('hibff_auth_token', token);
    }
    navigate(to, { replace: true });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <p className="text-gray-500 text-sm">Signing you in…</p>
    </div>
  );
};

export default MagicLoginRedirect;
